export enum WebRouletteStatus {
    notPurched = 1,
    expired,
    spinsLimit,
    purchedButNotAvailable,
    purchedNotLimitPackage,
    purched,
    purchedFreePackage,
    spinsLimitForFreePackage
}